import { render, staticRenderFns } from "./addHomePatient.vue?vue&type=template&id=1c006ae2&scoped=true"
import script from "./addHomePatient.vue?vue&type=script&lang=js"
export * from "./addHomePatient.vue?vue&type=script&lang=js"
import style0 from "./addHomePatient.vue?vue&type=style&index=0&id=1c006ae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c006ae2",
  null
  
)

export default component.exports